module.exports = __webpack_public_path__ + "static/canapply-cover-ac635072741ec21db43f83ded9735577.jpg";